import React, { Suspense } from 'react';
import VideoSubHeading from '../components/videoSubHeading';

function Videoexp() {
  const [isVideoLoaded, setIsVideoLoaded] = React.useState(false);

  return (
    <div className="flex flex-col justify-center items-center w-full mt-20 max-md:hidden">
      <div className="flex flex-col xl:w-[70%] max-xl:w-[85%] max-lg:w-[85%] max-sm:w-[90%] justify-start pt-16 max-sm:pt-0 items-center text-center">
        <Suspense fallback={<div></div>}>
          <VideoSubHeading />
        </Suspense>
        <span
          className={`max-lg:w-full text-center text-neutral-400 text-[20px] xxl:text-3xl max-sm:text-sm leading-[28px] xxl:leading-[40px] pb-12`}
        >
          At Pixa, we are pushing the boundaries of what&apos;s possible with AI
          powered companions. By integrating cutting edge sensors, advanced
          processors & latest GPT technology, we&apos;re creating a personalised
          companion for everyone
        </span>
      </div>
      <div className="relative w-[90%] h-[calc(100vh_-_150px)] mb-12 overflow-hidden">
        {!isVideoLoaded && (
          <img
            src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723729156/pixa-pie/hero/speaker_3d_bg.webp"
            alt="pie-3d-working"
            className="object-contain object-center w-[100%] absolute inset-0"
          />
        )}
        <video
          src="https://res.cloudinary.com/dx6dieevo/video/upload/f_auto,q_auto:good,w_auto/v1724680860/pixa-pie/hero/speaker_3d_bg_video.mov"
          autoPlay
          muted
          className={`object-contain xxl:object-contain max-xl:object-contain object-center h-full w-full transition-opacity duration-500 ${
            isVideoLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          onLoadedData={() => setIsVideoLoaded(true)}
        ></video>
      </div>
    </div>
  );
}

export default Videoexp;
